// Lightweight GA4 helper — safe no-op if consent not granted or gtag missing.
const CONSENT_KEY = "k29_consent_v1";

export function getStoredConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY); // "granted" | "denied" | null
  } catch {
    return null;
  }
}

export function applyStoredConsent() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const stored = getStoredConsent();
  if (stored === "granted") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
  }
  // If null or "denied" → leave default (denied)
}

export function grantConsent() {
  try { localStorage.setItem(CONSENT_KEY, "granted"); } catch {}
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
    window.gtag("event", "consent_granted");
  }
}

export function denyConsent() {
  try { localStorage.setItem(CONSENT_KEY, "denied"); } catch {}
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
    });
  }
}

// Send a custom event; safe to call before consent — GA respects consent mode.
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);

    // Also fire a dedicated event name for key CTA actions so they appear
    // directly in GA4 Events report without needing custom dimensions.
    if (name === "cta_click" && params.action) {
      const dedicatedName = `${params.action}_click`;
      window.gtag("event", dedicatedName, {
        location: params.location,
      });
    }
  } catch {}
}
